export default "__VITE_PUBLIC_ASSET__779b204e__"